<template>
  <div class="app-shell" :class="{ 'brand-site': !isFullScreenRoute }">
    <AppHeader v-if="!isFullScreenRoute" />
    <router-view v-slot="{ Component, route }">
      <component :is="Component" v-if="route.meta.fullScreen" />
      <div v-else :key="route.path" class="route-page">
        <component :is="Component" />
      </div>
    </router-view>
    <AppFooter v-if="!isFullScreenRoute" />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';
import './styles/brand.css';

export default {
  name: 'App',
  components: { AppHeader, AppFooter },
  computed: {
    isFullScreenRoute() {
      return Boolean(this.$route.meta.fullScreen);
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  background: var(--mola-ivory, #fef9ef);
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

.app-shell {
  font-family: 'Arial', sans-serif;
  background: #111111;
  color: #4a5a66;
  min-height: 100vh;
}
</style>
